<template>
  <div class="d-flex flex-column justify-content-center px-1">
    <HeaderBar/>
    <div
      class="d-flex flex-column mb-2 mt-4"
      style="font-size: 15px; font-weight: 500"
    >
        <div class="add-economic-record-title1 mt-2 text-center "> Exámenes</div>
        <div class="d-flex justify-content-center headTitle">{{fincaName}}</div>
    </div>
    <validation-observer ref="GanForm" >
      <div >
        <b-form class="mt-2" @submit.prevent="">
          <!-- date -->

          <b-form-group class="datePicker flex-fill" label="Fecha">
            <validation-provider
            #default="{ errors }" 
            name="Fecha" 
            rules="required">
              <b-form-datepicker v-model="date" class="form-control" 
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :min="minCfgDate" :max="maxCfgDate"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label="Tipo de examen" label-for="examTypes">
          <validation-provider
            #default="{ errors }" 
            name="Tipo de examen" 
            rules="required">
              <b-form-select
                id="examTypes"
                v-model="selectedExamTypes"
                :options="examTypes"
                :values="examTypes.value"
                label="text"
                class="flex-fill w-100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div>
            <div>Resultado</div>
            <b-form-group v-slot="{ ariaDescribedby }">
              <div class="d-flex">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="Positivo"
                  class="mr-1"
                  >Positivo</b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="Negativo"
                  class="mr-1"
                  >Negativo</b-form-radio
                >

                <b-form-radio
                  v-model="selected"
                  name="some-radios"
                  value="Otro"
                  >Otro</b-form-radio
                >
                <validation-provider
                  #default="{ errors }"
                  name="anony"
                  vid="anony"
                  rules="required"
                >
                  <b-form-input
                    id="anony"
                    v-model="selected"
                    :state="errors.length > 0 ? false : null"
                    name="anony"
                    class="ml-1 w-75"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-form-group>
          </div>

          <b-form-group label="Seleccionar Animal" label-for="animalSelector">
            <validation-provider #default="{ errors }" name="Animal" rules="required">
              <b-form-select v-model="selectedAnimal" :options="animalOptions" value-field="id" text-field="text"
                label="text">
              </b-form-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- submit buttons -->
          <div class="d-flex align-items-center justify-content-center mb-5">
            <b-button type="submit" v-on:click="addHealthRecord"
            class="bg-primary dataButton mt-2 d-flex align-items-center justify-content-center ml-3">
            <div class="ml-5">Incluir Evento</div>
            <div class="pl-5" style="color: #d7b92c">
              <feather-icon icon="PlusIcon" size="18" />
            </div>
            </b-button>
          </div>
        </b-form>
      </div>
    </validation-observer>
    <ControlMenu />
  </div>
</template>

<script>
import axios from "axios"
import vSelect from "vue-select"
import { required } from '@validations'
import "vue-select/dist/vue-select.css"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import {
  BButton,
  BFormTextarea,
  BFormSelect,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BFormDatepicker,
  BFormRadio,
} from "bootstrap-vue";
import ControlMenu from "@/components/ControlMenu.vue"
import HeaderBar from '@/components/HeaderBar.vue'
import flatPickr from "vue-flatpickr-component"
import { VueGoodTable } from "vue-good-table"

export default {
  components: {
    BButton,
    BForm,
    flatPickr,
    BFormSelect,
    BFormGroup,
    ControlMenu,
    HeaderBar,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormRadio,
    BFormTextarea,
    VueGoodTable,
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 119)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {
      status: "",
      date: now,
      maxCfgDate:maxDate,
      minCfgDate:minDate,
      selected: null,
      selectedExamTypes: 0,
      selectedAge: null,
      selectAge: [{}],
      examTypes: [],
      type_id:3,
      ageOptions: [
        { text: "10" },
        { text: "15" },
        { text: "21" },
        { text: "30" },
        { text: "33" },
      ],
      fincaName:localStorage.getItem('currentFarmName'),
      animal:{
          sex:0
      },
      selectedAnimal: null,
      animalOptions: [],
      animals: [],
      pageLength: 25,
      columns: [
          {
              label: 'CODIGO',
              field: 'number',
          },  
          {
              label: 'ANIMAL',
              field: 'name',
          },
          {
              label: 'SEXO',
              field: 'sex',
          },
          {
              label: 'PESO',
              field: 'weight',
          },
          {
              label: 'EDAD',
              field: 'age',
          },
      ],
      rows: [],
      exams:[],
    };
  },
  methods: {
    async fetchExamTypes(config) {

      fetch(this.$apiUrl+"list/exam_types", config)
        .then((response) => response.json())
        .then((result) => {
          this.examTypes = result.exam_types.map((item) =>{ return { text: item.name,value:item.id}})
        })
        .catch((error) => console.log("error", error));
      // ------
    },

    async fetchAnimals(config) {
      let farmId = localStorage.getItem('currentFarm');
      fetch(this.$apiUrl + "list/animals?farm_id=" + farmId + "&state=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          this.animalOptions = result.animals.map(item => { return { id: item.id, text: item.name } });
        })
    },

    

    addHealthRecord() {
      this.$refs.GanForm.validate().then(success => {
        if(success){
          let self=this;
          const token = localStorage.getItem("accessToken");
          const config = {headers: {"X-Authorization": `Bearer ${token}`}};
          this.exams = [{ animal_id: this.selectedAnimal, exam_type_id:this.selectedExamTypes,result:this.selected,date:this.date,type_id:this.type_id,farm_id:localStorage.getItem('currentFarm') }]; 
          console.log(this.exams);
          var request= this.exams.map(items =>this.$http.post("add/health_records", items, config));
          axios.all(request)
          .then(()=>{
            this.$swal({
                title: 'Registro de exámenes',
                text: 'Se insertaron los registros de exámenes satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
            }).then(function(){
              history.back();
            });
          });
        }
      })
    }


  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.fetchAnimals(config);
    this.fetchExamTypes(config);
  },
};
</script>

<style lang="scss">
.titleExam {
  font-weight: 600;
  font-size: 24px;
}
.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/page-auth.scss";
</style>
